















module.exports =
  props: ['event']




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/events/hs_event.vue